import * as ReportTypes from 'features/frontoffice/actions/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import routePaths from 'routes/routePaths';
import { store } from 'store/store';
import { validateAndOpenReport } from '../actions/actions';
import ReportViewerDialog from "./reportViewerDialog";

const ReportViewerDialogWrapper = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantCd, workbook, dashboard } = useParams();

  const openReportViewDialog = useSelector((state) => state.fo.openReportViewDialog);
  const { currentReportCategory: category, currentReportTitle: reportTitle, reportBaseUrl, reportUrl } = useSelector((state) => state.fo);

  useEffect(() => {
    if(tenantCd && workbook && dashboard && !openReportViewDialog) {
      dispatch(validateAndOpenReport(tenantCd, workbook, dashboard));
    }
  }, [tenantCd, workbook, dashboard]); // eslint-disable-line react-hooks/exhaustive-deps

  const closeReportView = () => {
    store.dispatch({
      type: ReportTypes.CLOSE_REPORT_VIEWER_REQUEST
    });
    if(reportBaseUrl){
      navigate(reportBaseUrl);
    } else {
      let reportOrigin = null;
       try {
         const raw = sessionStorage.getItem('reportOrigin');
         reportOrigin = raw ? JSON.parse(raw) : null;
       } catch (e) {
         reportOrigin = null;
       }
      navigate(reportOrigin?.reportBaseUrl || routePaths.frontOffice);
    }
  };

  return (
    <>
      {tenantCd && workbook && dashboard && (
        <ReportViewerDialog
        key={`${tenantCd}-${workbook}-${dashboard}`}
        open={openReportViewDialog}
        reportSource={reportUrl}
        category={category}
        title={reportTitle}
        onClose={() => closeReportView()}
        tenantCd={tenantCd}
      />
      )}
    </>
  );

}

export default ReportViewerDialogWrapper